import React from 'react';
import { Reveal } from './Reveal';
import { stats } from '../data/stats';
export function StatsBar() {
  return <section className="border-y border-brand-dark bg-brand-alt py-8" data-id="element-162" data-mp="1tbjghngupucr">
      <Reveal className="mx-auto grid max-w-5xl grid-cols-2 gap-y-8 px-4 text-center md:grid-cols-4 md:gap-8" data-id="element-163" data-mp="1ob57o37fegdo">
        {stats.map(([value, label], index) => <div key={label} className={`flex flex-col items-center justify-center ${index > 0 ? 'md:border-l md:border-brand-dark' : ''}`} data-id="element-164" data-mp="1jc2991lyb8eo" data-mpi={index}>
            <span className="mb-1 font-display text-3xl font-bold text-brand-blue md:text-4xl" data-id="element-165" data-mp="19lpjmuza4p1o">{value}</span>
            <span className="text-[10px] font-bold uppercase tracking-wider text-brand-gray md:text-xs" data-id="element-166" data-mp="15lfbpcrxfok6">{label}</span>
          </div>)}
      </Reveal>
    </section>;
}